module.exports = __webpack_public_path__ + "static/media/SDFSA_4-682w.524afc34.webp";